import { createContext } from 'react';

export const RecipesContext = createContext({ isAllCategoriesPage: false });
